import { render, staticRenderFns } from "./CaseFileUpload.vue?vue&type=template&id=32062ad6&scoped=true&"
import script from "./CaseFileUpload.vue?vue&type=script&lang=ts&"
export * from "./CaseFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFileUpload.vue?vue&type=style&index=0&id=32062ad6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32062ad6",
  null
  
)

export default component.exports